import type { AudienceProcessingStatus, AudienceIdentifierType } from '@troia-v3/types';
import type { IconName } from '@/shared/icons';
import type { StatusPillVariant } from '@/shared/components/ui/StatusPill';

/**
 * Metadados de apresentação de Públicos (status de processamento + tipo de
 * identificador). Centralizado para o Card e a Linha da tabela compartilharem
 * os mesmos rótulos/cores (evita divergência). Cores via StatusPill shared (F62).
 */
export const audienceStatusMeta: Record<
  AudienceProcessingStatus,
  { label: string; variant: StatusPillVariant; rank: number }
> = {
  idle: { label: 'Pronto', variant: 'success', rank: 0 },
  processing: { label: 'Processando', variant: 'info', rank: 1 },
  failed: { label: 'Falhou', variant: 'error', rank: 2 },
};

export const audienceTypeMeta: Record<
  AudienceIdentifierType,
  { label: string; icon: IconName }
> = {
  email: { label: 'Email', icon: 'mail' },
  phone: { label: 'Telefone', icon: 'phone' },
};

export const formatEntries = (n: number): string => n.toLocaleString('pt-BR');
